import React from 'react';

import { i18n } from 'src/i18n';

import { IconTheme } from './icon-theme';
import { IconType } from './icon-type';
import { StyledBinIcon, StyledCartIcon, StyledEditIcon } from './icon.styled';

export interface IconProps {
  iconType: IconType;
  iconTheme: IconTheme;
  disabled?: boolean;
}

export const Icon: React.FunctionComponent<IconProps> = (props) => {
  const { iconType, iconTheme, disabled, ...rest } = props;

  switch (iconType) {
    case IconType.BIN:
      return <StyledBinIcon title={i18n.image.delete} $disabled={disabled} $iconTheme={iconTheme} {...rest} />;
    case IconType.CART:
      return <StyledCartIcon title={i18n.image.shoppingCart} $disabled={disabled} $iconTheme={iconTheme} {...rest} />;
    case IconType.EDIT:
      return <StyledEditIcon title={i18n.image.edit} $disabled={disabled} $iconTheme={iconTheme} {...rest} />;
    default:
      throw new Error(`Unsupported icon type ${iconType}`);
  }
};
